var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.919c0 .33-.16.63-.43.82l-7.21 5.05c-.59.41-1.43.09-1.56-.62-.15-.86.05-1.87.65-2.96l3.12-5.61 2.94-5.29c.23-.41.48-.77.74-1.08.6-.7 1.75-.25 1.75.67v9.02zM13.18 13.739a.997.997 0 0 1-.43-.82v-9.02c0-.92 1.15-1.37 1.75-.67.26.31.51.67.74 1.08l2.94 5.29 3.12 5.61c.6 1.09.8 2.1.65 2.96-.13.71-.97 1.03-1.56.62l-7.21-5.05zM11.41 15.04c.33-.22.87-.22 1.2 0l6.15 4.1c1.63 1.09 1.36 1.98-.6 1.98H5.85c-1.95-.01-2.22-.9-.59-1.98l6.15-4.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldTriangle);
export default __webpack_public_path__ + "static/media/vuesax-bold-triangle.ac779b04dccee161ed1128723351d092.svg";
export { ForwardRef as ReactComponent };